import { render, staticRenderFns } from "./DocTypeList.vue?vue&type=template&id=7f7efd4f&"
import script from "./DocTypeList.vue?vue&type=script&lang=js&"
export * from "./DocTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports